import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { returnRetrievalRankingDebugInfo } from "@faire/retailer-shared/search/loggedInBrandLeanProductTilesRequest";
import { getSettingShouldDisplayRetrievalAndRankingDebugInfo } from "@faire/retailer-visitor-shared/settings/getSettingShouldDisplayRetrievalAndRankingDebugInfo";
import { UserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { cachingApi, cachingApiWithLookup } from "@faire/web--source/common/cachingApi";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { createStoreHook } from "@faire/web--source/ui/hooks/useStore";
import { path as getPathPublishedBrandProductCollectionMetadata } from "@faire/web-api--source/api/brand/brandToken/published-product-collection-metadata/get";
import fetchCategoryPageLayoutElements from "@faire/web-api--source/api/layout/category-page/post";
import brandSearch from "@faire/web-api--source/api/v2/search/brands/get";
import getFeaturedProducts from "@faire/web-api--source/api/v2/search/brandToken/featured-products/get";
import fetchProductCatNav from "@faire/web-api--source/api/v2/search/products/cat-nav/post";
import { path as getPathProductsFromBrandFilters } from "@faire/web-api--source/api/v2/search/products/from-brand/filters/post";
import searchProductsFromBrand, { path as getPathProductsFromBrand } from "@faire/web-api--source/api/v2/search/products/from-brand/post";
import queryProductsFilterService from "@faire/web-api--source/api/v3/search/products/filters/post";
import queryProductsSearchService from "@faire/web-api--source/api/v3/search/products/post";
var queryProductsWrapper = function(data, abortSignal) {
    return queryProductsSearchService(data, {
        signal: abortSignal
    });
};
var queryFiltersWrapper = function(data, abortSignal) {
    return queryProductsFilterService(data, {
        signal: abortSignal
    });
};
var fetchProductCatNavWrapper = function(data, requestOptions) {
    data.return_retrieval_and_ranking_debug_info = returnRetrievalRankingDebugInfo(UserStore.get().user, getSettingShouldDisplayRetrievalAndRankingDebugInfo());
    // New search service API that searches the products.
    return fetchProductCatNav(data, requestOptions);
};
// need this for tests
var brandSearchWrapper = function(payload, requestOptions) {
    return brandSearch(payload, requestOptions);
};
export var ProductCacheStore = function ProductCacheStore() {
    "use strict";
    var _this = this;
    _class_call_check(this, ProductCacheStore);
    this.fetchProductCatNav = cachingApi(fetchProductCatNavWrapper);
    this.fetchCategoryPageLayoutElements = cachingApi(fetchCategoryPageLayoutElements);
    // searchProductsFromBrandCache needs wrapper to enable manual cache invalidation
    // when a product's state is modified
    this.searchProductsFromBrandCache = cachingApiWithLookup(function(request) {
        if (!request.brand_token) {
            return Promise.reject("Empty brand_token");
        }
        return searchProductsFromBrand(request);
    });
    this.queryProductsMemoized = cachingApi(queryProductsWrapper);
    this.queryFiltersMemoized = cachingApi(queryFiltersWrapper);
    this.brandSearchMemoized = cachingApi(brandSearchWrapper);
    this.getFeaturedLeanProductTilesMemoized = cachingApi(getFeaturedProducts);
    this.searchProductsFromBrand = function(payload) {
        _this.searchProductsFromBrandCache.lookup.add(payload);
        return _this.searchProductsFromBrandCache.cache(payload);
    };
    // Search results view caches
    this.queryProducts = function(payload, abortSignal) {
        return _this.queryProductsMemoized(payload, abortSignal);
    };
    this.queryFilters = function(payload, abortSignal) {
        return _this.queryFiltersMemoized(payload, abortSignal);
    };
    // Category view results view caches
    this.brandSearch = function(payload, requestOptions) {
        return _this.brandSearchMemoized(payload, requestOptions);
    };
    this.getFeaturedLeanProductTiles = function(brandToken, queryParams) {
        return _this.getFeaturedLeanProductTilesMemoized(brandToken, queryParams);
    };
    // Invalidate a brand's product cache when products of that
    // brand have had their state modified
    this.invalidateCache = function(brandToken, queryClient) {
        if (brandToken === undefined) {
            return;
        }
        // Invalidate the entire cache of search calls if any product is favorited
        _this.queryProductsMemoized.clear();
        _this.queryFiltersMemoized.clear();
        _this.brandSearchMemoized.clear();
        _this.getFeaturedLeanProductTilesMemoized.clear();
        _this.searchProductsFromBrandCache.lookup.forEach(function(payload) {
            if (payload.brand_token === brandToken) {
                _this.searchProductsFromBrandCache.cache.delete(payload);
            }
        });
        if (queryClient) {
            queryClient.removeQueries({
                queryKey: [
                    getPathPublishedBrandProductCollectionMetadata(brandToken)
                ]
            });
            queryClient.removeQueries({
                queryKey: [
                    getPathProductsFromBrand(),
                    {
                        brand_token: brandToken
                    }
                ]
            });
            queryClient.removeQueries({
                queryKey: [
                    getPathProductsFromBrandFilters(),
                    {
                        brand_token: brandToken
                    }
                ]
            });
        }
    };
    this.invalidateCacheAfterPlacingAndCancelingOrders = function() {
        _this.brandSearchMemoized.clear();
        _this.queryProductsMemoized.clear();
        _this.queryFiltersMemoized.clear();
    };
    this.invalidateCacheAfterInsiderEnrollment = function() {
        _this.brandSearchMemoized.clear();
    };
};
ProductCacheStore.get = singletonGetter(ProductCacheStore);
export var useProductCacheStore = createStoreHook(ProductCacheStore);
